<app-tabs [tabs]="leadsTabs" ></app-tabs>

<router-outlet></router-outlet>